import { LinkButton, useDeviceType } from '@cian/ui-kit';
import * as style from './Banner.css';
import classnames from 'classnames';
import { openAskProffesional } from '../tracking';

export const Banner: React.FC = () => {
  const device = useDeviceType();

  return (
    <div
      className={classnames(
        style['container'],
        device !== 'desktop' && style['container-tablet'],
        device === 'phone' && style['container-phone'],
      )}
    >
      <div className={style['title']}>Не нашли нужной информации?</div>
      <LinkButton
        theme="fill_white_primary"
        href="https://www.cian.ru/add-vopros/"
        target="_blank"
        size="M"
        onClick={openAskProffesional}
        fullWidth={device !== 'desktop'}
      >
        Спросите у профессионала
      </LinkButton>
    </div>
  );
};
